import * as React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import {
    Box,
    Button,
    Dialog,
    AppBar,
    Toolbar,
    IconButton,
    Slide,
    Backdrop,
    CircularProgress,
    Tabs,
    Tab,
    Alert,
} from '@mui/material';
import swal from 'sweetalert';
import ValidationFileName from './ValidationFileName';
import { useNavigate } from 'react-router-dom';
import AgreementModal from '../../components/AgreementModal';
import { PLANS_PATH } from '../../permissions/viewRegistry';
import {
    useAcceptFile,
    useDownloadValidation,
    useUpdateFileName,
    useFetchValidationFile,
    useFetchPolicyPdf,
} from '../../hooks/useFiles';
import { useUpdateAgreement } from '../../hooks/useAuth';
import TabPanel from '../../components/TabPanel';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function ReviewPage(props) {
    /// validation page for files ///
    const userdata = useSelector((state)=> state.UserReducer.user);
    const file = useSelector((state) => state.FileReducer.file);
    const loading = useSelector((state) => state.FileReducer.fileLoading);
    const companyId = useSelector((state) => state.CompanyReducer.userCompanies[0]);
    const [results, setResults] = React.useState(file.file);
    const [value, setValue] = React.useState(0);
    const [summary, setSummary] = React.useState(file.summary);
    const dispatch = useDispatch();
    const acceptFile = useAcceptFile();
    const downloadValidation = useDownloadValidation();
    const updateFileName = useUpdateFileName();
    const fetchValidationFile = useFetchValidationFile();
    const fetchPolicyPdf = useFetchPolicyPdf();
    const updateAgreement = useUpdateAgreement();
    const navigate = useNavigate();

    const isMountedRef = React.useRef(true);
    React.useEffect(() => {
        isMountedRef.current = true;
        return () => { isMountedRef.current = false; };
    }, []);

    // const [clientName, setClientName] =  React.useState('');
    const [jobName, setJobName] =  React.useState('');
    const [areaName, setAreaName] =  React.useState('');
    const [floorName, setFloorName] =  React.useState('');
    const [fileName, setFileName] = React.useState(file.info.name);

    const pdf = useSelector((state)=> state.FileReducer.PDFfile.file);
    const [pdfUrl, setPdfUrl] = React.useState(`${pdf}`);
    const [pdfStatus, setPdfStatus] = React.useState();

    let user = {
        Id: userdata.id,
        hasAcceptedUploadPolicy: userdata.hasAcceptedUploadPolicy,
        hasAcceptedDownloadPolicy: userdata.hasAcceptedDownloadPolicy,
        hasConfirmedEmail: userdata.hasConfirmedEmail,
        hasReadPrivacyPolicy: userdata.hasReadPrivacyPolicy,
    }

    function changePDFStatus(event){
        if (!isMountedRef.current) return;
        setPdfStatus(!pdfStatus);
        if (event === true) {
            user = {
                Id: userdata.id,
                hasAcceptedUploadPolicy: userdata.hasAcceptedUploadPolicy,
                hasAcceptedDownloadPolicy: 1,
                hasConfirmedEmail: userdata.hasConfirmedEmail,
                hasReadPrivacyPolicy: userdata.hasReadPrivacyPolicy,
            }
            updateAgreement.mutate(user);
            // Do not call handleClose() so Validation re-renders and shows the validation content
        }
        else if (event === false) {
            user = {
                Id: userdata.id,
                hasAcceptedUploadPolicy: userdata.hasAcceptedUploadPolicy,
                hasAcceptedDownloadPolicy: 0,
                hasConfirmedEmail: userdata.hasConfirmedEmail,
                hasReadPrivacyPolicy: userdata.hasReadPrivacyPolicy,
            }
            updateAgreement.mutate(user);
        }
    };

    React.useEffect(() => {
        if (!isMountedRef.current) return;
        setResults(file.file);
        setSummary(file.summary);
        setFileName(file.info?.name);
        if (userdata.hasAcceptedDownloadPolicy === 0){
            setPdfStatus(false)
        }
        if (userdata.hasAcceptedDownloadPolicy === 1){
            setPdfStatus(true)
        }
    }, [file.file, file.summary, file.info?.name, userdata.hasAcceptedDownloadPolicy]);

    React.useEffect(() => {
        if (pdf && isMountedRef.current) {
            setPdfUrl(`${pdf}`);
        }
    }, [pdf]);

    // Only fetch policy PDF when the agreement gate is open and Plans has not already loaded it.
    React.useEffect(() => {
        if (!props.status || userdata.hasAcceptedDownloadPolicy !== 0 || pdf) {
            return;
        }
        const controller = new AbortController();
        fetchPolicyPdf.mutate({
            pdfType: 2,
            setPdfUrl: (url) => {
                if (isMountedRef.current) {
                    setPdfUrl(url);
                }
            },
            signal: controller.signal,
        });
        return () => {
            controller.abort();
        };
    }, [props.status, userdata.hasAcceptedDownloadPolicy, pdf]);

    const handleClose = () => {
        dispatch({ type: "VALIDATION_RESET" });
        props.change(false);
        // setClientName('');
        if (!isMountedRef.current) return;
        setJobName('');
        setAreaName('');
        setFloorName('');
        setFileName('');
        setResults();
        setValue(0);
        setSummary();
    };

    const handleAccept = () => {
        if (file.info.name?.includes(defaultFile)){
            swal({
                text: 'Default File Name found, please enter a unique file name.',
                icon: "error"
            });
            return;
        }
        const acceptedId = file.info.id;
        acceptFile.mutate(
            { id: acceptedId, acceptance: 1 },
            {
                onSuccess: () => {
                    dispatch({ type: "VALIDATION_RESET" });
                    props.change(false);
                    if (props.onAccepted) {
                        props.onAccepted(acceptedId);
                    } else {
                        navigate(PLANS_PATH);
                    }
                },
            },
        );
    };

    const handleDownload = () => {
        downloadValidation.mutate(file.info);
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const errorAlert = (error) => {
        if ( error === 0 || error === 1 || error === 20) {
            return "";
        }
        else {
            return <Alert sx={{ display: 'flex', justifyContent: 'center', textAlign:'center', width:'100vw' }} severity='error'>
                CRITICAL ERROR: File contains a crital error.
                <br/>
                Accepting this file with the error is allowed, but with the provision that a user accepts responsibility for the error.
                <br/>
                Alternatively, you can rework the file from Upload.

            </Alert>
        }
    };

    const item = {
        id: file.info.id,
        Name: fileName,
    };

    const defaultFile = "NewPlan";
    const actualFile = fileName;

    /// Set File Name
    function submitName(){
        if (actualFile?.includes(defaultFile)){
            swal({
                text: 'Default File Name found, please enter a unique file name.',
                icon: "error"
            });
            return;
        } else if(jobName === ""){
            swal({
                text: 'Job Name required, please enter a job name.',
                icon: "error"
            });
            return;
        } else if (floorName === ""){
            swal({
                text: 'Floor level required, please enter a floor level.',
                icon: "error"
            });
            return;
        }
        else if ((jobName != '')&&(floorName != '')){
            swal({
                    title: "YOU ARE ABOUT TO UPDATE FILE NAME",
                    text: `New File Name: ${fileName}?`,
                    icon: "warning",
                    buttons: true,
                    dangerMode: false,
                })
            .then((willUpdate) => {
                if (willUpdate) {
                    updateFileName.mutate(item, {
                        onSuccess: (id) => {
                            fetchValidationFile.mutate(id);
                        },
                    });
                    setJobName('');
                    setAreaName('');
                    setFloorName('');
                    setFileName(file.info.name);
                } else {
                    swal({
                        title: `File Name not updated.`
                    });
                }
            });
        }
    };

    function resetInputs(){
        setJobName('');
        setAreaName('');
        setFloorName('');
        setFileName(file.info.name);
    };

    const handleUpload = () => {
        submitName();
    };

  if (props.status && userdata.hasAcceptedDownloadPolicy === 0) {
        return (
            <AgreementModal
                open={true}
                onClose={handleClose}
                title="Downloader Agreement"
                description="Read and accept the User Agreement to download plans."
                pdfUrl={pdfUrl}
                checked={pdfStatus}
                onToggle={changePDFStatus}
                acceptLabel="Accept Download Policy"
            />
        );
    }

  return (
    <div>
        <Dialog
            fullScreen
            open={props.status}
            // Close only via the X / accept actions. Escape and focus-trap noise otherwise snap back to Plans.
            disableEscapeKeyDown
            onClose={() => {}}
            TransitionComponent={Transition}
        >
            <div style={{display:'flex', flexDirection:'column', height:'100%', position:'relative'}}>
                <AppBar style={{backgroundColor:'black'}}>
                    <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Box>
                            <Button autoFocus color="inherit" onClick={handleDownload} variant="outlined">
                                Download
                            </Button>
                            <Button sx={{ marginLeft: '10px' }} autoFocus color="inherit"
                                onClick={()=>handleAccept()} variant="outlined">
                                Accept
                            </Button>
                        </Box>
                    </Toolbar>
                </AppBar>
                <Box style={{position:'fixed', top:'7%', height:'90vh', width:'100vw'}}>
                    <Tabs value={value} onChange={handleChange} centered >
                        <Tab label="File Name"/>
                        <Tab label="Validation & Summary"/>
                    </Tabs>
                    {errorAlert(file.error)}
                    <TabPanel value={value} index={0}>
                        <ValidationFileName props={props} companyId={companyId}
                        setJobName={setJobName} setAreaName={setAreaName} setFloorName={setFloorName} handleUpload={handleUpload} setFileName={setFileName}
                        jobName={jobName} areaName={areaName} floorName={floorName} file={file} fileName={fileName}/>

                    </TabPanel>
                    <TabPanel value={value} index={1} style={{height: '100%', maxHeight: '80vh' , overflowY:'scroll'}}>
                        <Box m={2} sx={{  display: 'flex', flexDirection:'row', justifyContent: 'center',}}>
                            <div style={{flex:2, margin: 20}}>
                                <h4 style={{textAlign:'left'}}>Validation:</h4>
                                <pre style={{textAlign:'left'}}>
                                    {results}
                                </pre>
                            </div>
                            <div style={{flex:1, margin:20}}>
                                <h4 style={{textAlign:'left'}}>Summary:</h4>
                                    <pre style={{textAlign:'left'}}>
                                        {summary}
                                    </pre>
                            </div>
                        </Box>
                    </TabPanel>
                </Box>
                {loading && (
                    <Backdrop
                        sx={{ color: '#fff', position: 'absolute', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={true}
                    >
                        <CircularProgress size={100} color="warning" />
                    </Backdrop>
                )}
            </div>
        </Dialog>
    </div>
  );
}